import {Maybe} from '@coolcolduk/typescript-util';
import {undefinedIfThrowSync} from '@coolcolduk/util';

/**
 * Format a status note as a JSON layout if it is JSON, otherwise return original note
 * @param statusNote
 * @returns undefined, null if the input is invalid, otherwise the formatted JSON string
 * @deprecated potentially move to util
 */
export default function statusNoteFormatter(statusNote?: Maybe<string>) {
  if (!statusNote) return statusNote;

  return undefinedIfThrowSync(() => JSON.stringify(JSON.parse(statusNote), null, 2)) || statusNote;
}
